import { render, staticRenderFns } from "./ChatSingleRoom.vue?vue&type=template&id=4c4f01ea&"
import script from "./ChatSingleRoom.vue?vue&type=script&lang=js&"
export * from "./ChatSingleRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports